<template>
  <div class="teacher-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="left">
        <img
          class="teacher-img"
          src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/fqm.jpeg"
          alt=""
        />
        <div class="bold-desc">Assistant Professor</div>
        <div class="email-desc">fangqiming@hdu.edu.cn</div>
      </div>
      <div class="right">
        <div class="bold-title">个人介绍 INTRODUCTION</div>

        <div class="right-content">
          <p class="para">
            <strong>方启明</strong>，博士，讲师。
            2010年博士毕业于清华大学，2011-2013年在清华大学从事博士后研究，2019-2020年沙特阿卜杜拉国王科技大学（KAUST）访问学者。
          </p>
          <p class="para">
            主要研究领域为<strong>分布式计算与系统、人工智能、类脑计算</strong>等，主持和参与多项国家自然科学基金、浙江省自然科学基金、国家863计划重点项目、浙江省重点研发计划项目，在国内外学术期刊及国际会议上发表论文20余篇，担任TNNLS、TCDS、FCS等学术期刊论文评审，担任国家自然科学基金、浙江省自然科学基金评审。
          </p>
        </div>
        <div class="bold-title">科研项目 Project</div>
        <div class="right-content">
          ◎ 浙江省重点研发计划项目：“重大活动公共安全智
          能防控平台开发及应用示范”(2021C03156)，2021-01至2023-12，240万
          (在研，参与)；
          <br />◎
          浙江省自然科学基金项目:”基于生物视觉机理融合特征提取的多层脉冲神经网络模型研究”(LY19F030021),2019-01至2021-12，10万(在研,主持);
          <br />◎
          浙江省重点研发计划项目：“区块链关键技术研究与技术交易应用”(2019C01056)，2018-07至2021-06，300万
          (在研，参与)； <br />◎
          国家自然科学基金项目：“基于神经拟态模型的并发数据流无监督在线异常检测技术”(61603119)，2017-01至2019-12，25万
          (已结题，主持)； <br />◎
          浙江省重点研发计划项目：“促进成果转化的科技大数据服务平台开发及应用”(2017C01009)，2016-07至2019-06，300万
          (已结题，参与)； <br />◎
          国家自然科学基金项目：“物联网环境信息协同感知与处理研究”(61473109)，2015-01至2018-12，84万
          (已结题，参与)； <br />◎
          浙江省自然科学基金项目：“大规模无线传感网中的高效Top-K查询处理技术研究”(LQ14F020013)，2014-01至2016-12，5万
          (已结题，主持)； <br />◎
          国家863计划重点项目：“面向地球系统模式研究的高性能计算支撑软件系统”(2010AA012400)，2010-08至2012-12，2958万
          (已结题，参与)； <br />◎
          浙江省重点科技创新团队子项目：“传感器网络海量数据分析与处理”(2009R50046-10)，2010-01至2012-12，10万
          (已结题，主持)。
        </div>
        <div class="bold-title">发表论文 SELECTED PUBLICATIONS</div>
        <div class="right-content">
          ◎ Dewen Seng, Fanshun Lv, Ziyi Liang, Xiaoying Shi, Qiming Fang.
          Forecasting Traffic Flows in Irregular Regions with Multi-graph
          Convolutional Network and Gated Recurrent Unit. Frontiers of
          Information Technology & Electronic Engineering. Accepted. (JCR Q2)
          <br />◎ Zhigang Gao, Yucai Huang, Leilei Zheng, Xiaodong Li, Huijuan
          Lu, Jianhui Zhang, Qingling Zhao, Wenjie Diao, Qiming Fang, Jinglong
          Fang. A Student Attendance Management Method Based on Crowdsensing in
          Classroom Environment. IEEE Access, 2021, 9: 31481~31492. (JCR Q2)
          <br />◎ Haoyang Li, Shuye Tian, Yu Li, Qiming Fang, Renbo Tan, Yijie
          Pan, Chao Huang, Ying Xu, Xin Gao. Modern Deep Learning in
          Bioinformatics. Journal of Molecular Cell Biology. 2020,
          12(11):823~827. (JCR Q2) <br />◎ Xiaoying Shi, Yang Wang, Fanshun Lv,
          Xiaohang Yang, Qiming Fang, Li Zhang. Multi-scale and Interactive
          Visual Analysis of Public Bicycle System. KSII Transactions on
          Internet and Information Systems, 2019, 13(6): 3037~3054. (JCR Q4)
          <br />◎ Xiaoliang Xu, Wensi Lu, Qiming Fang, Yixing Xia. A Visual
          Recognition Model Based on Hierarchical Feature Extraction and
          Multi-layer SNN. The 25th International Conference on Neural
          Information Processing (ICONIP2018), Siem Reap, Cambodia, 525~534.
          (CCF C) <br />◎ Xiaoliang Xu, Xin Jin, Rui Yan, Qiming Fang, Wensi Lu.
          Visual Pattern Recognition Using Enhanced Visual Features and
          PSD-Based Learning Rule. IEEE Transactions on Cognitive and
          Developmental Systems (TCDS), 2018, 10(2): 205~212. (JCR Q2) <br />◎
          Yuxiang Wang, Yixing Xia, Qiming Fang, Xiaoliang Xu. AQP++: A Hybrid
          Approximate Query Processing Framework for Generalized Aggregation
          Queries. Journal of Computational Science (JOCS), 2018, 26: 419~431.
          (JCR Q1) <br />◎ Xiaoying Shi, Zhenhai Yu, Qiming Fang, Quan Zhou. A
          Visual Analysis Approach for Inferring Personal Job and Housing
          Locations Based on Public Bicycle Data. ISPRS International Journal of
          Geo-information, 2017, 6(7): 205. (JCR Q2) <br />◎ Hong Zeng, Yidan
          Hu, Jin Fan, Haiyang Hu, Zhigang Gao, Qiming Fang. Arm Motion
          Recognition and Exercise Coaching System for Remote Interaction.
          Mobile Information Systems, 2016, 1: 1~14. (JCR Q4) <br />◎ 方启明,
          杨广文. E-SkipNet: 一种支持多属性范围查询的DHT网络.
          小型微型计算机系统, 2014, 35(10): 2308~2312. <br />◎ Qiming Fang,
          Guangwen Yang. Efficient Top-k Query Processing Algorithms in Highly
          Distributed Environments. Journal of Computers(JCP), 2014, 9(9):
          2000~2006. <br />◎ 方启明, 杨广文. 4R-TPUT:
          结构化对等网络中的高效top-k查询算法. 清华大学学报（自然科学版）, 2014,
          54(4): 480~484. (EI) <br />◎ Meiqi Zhu, Xiaomeng Huang, Songbin Liu,
          Haohuan Fu, Qiming Fang, Guangwen Yang. Optimize Multidimensional
          Arrays Queries with Heterogeneous Replica Method. The 8th IEEE
          International Conference on Networking, Architecture, and Storage
          (NAS2013), Xi’an, China. 272~276. (EI) <br />◎ Xingfa Shen, Xin Qian,
          Bei Zhao, Qiming Fang, Guojun Dai. Clapping and Broadcasting
          Synchronization in Wireless Sensor Networks. Tsinghua Science and
          Technology, 2011, 16(6): 632~639. (EI) <br />◎ Yongwei Wu, Jia Liu,
          Gang Chen, Qiming Fang, Guangwen Yang. Service-oriented Execution
          Model Supporting Data Sharing and Adaptive Query Processing. Journal
          of Cluster Computing, 2010, 13(2): 127~140. (JCR Q2) <br />◎ Qiming
          Fang, Ying Zhao, Guangwen Yang, Bo Wang, Weimin Zheng. Best Position
          Algorithms for Top-k Query Processing in Highly Distributed
          Environments. The 1st International Conference on Networking and
          Distributed Computing (ICNDC2010), 397~401. (EI) <br />◎ Bo Wang,
          Shifeng Shang, Qiming Fang, Weimin Zheng. Parallel Task Developing
          Based on Software Pipeline in Multicore System. The 2010 IEEE
          International Symposium on Parallel and Distributed Processing with
          Applications (ISPA2010), Taipei, Taiwan, 542~549. (EI) <br />◎ Qiming
          Fang, Ying Zhao, Guangwen Yang, Weimin Zheng. Scalable Distributed
          Ontology Reasoning Using DHT-based Partitioning. The 3rd Asian
          Semantic Web Conference (ASWC2008), Bangkok, Thailand, 91~105. (EI)
          <br />◎ 方启明, 杨广文, 武永卫, 郑纬民. 基于P2P的Web搜索技术.
          软件学报, 2008, 19(10): 2706~2719. (EI) <br />◎ 方启明, 杨广文,
          武永卫, 朱安平, 郑纬民. 面向P2P搜索的可定制聚焦网络爬虫.
          华中科技大学学报（自然科学版）, 2007, 35(sup II): 148~152. (EI)
          <br />◎ Bo Song, Guangwen Yang, Qiming Fang. Improving the Performance
          of MPI Applications over Computational Grid. The 6th International
          Conference on Grid and Cooperative Computing (GCC2007), Urumchi,
          China, 799~806. (EI)
        </div>
        <div class="bold-title">其他获奖/荣誉 Rewards</div>
        <div class="right-content">本科生毕业设计优秀指导教师</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.teacher-container {
  min-height: 100vh;
}
.item-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  padding-top: 60px;
}
.item-background {
  height: 60px;
}
.left {
  width: 15%;
}
.right {
  width: 85%;
  padding-left: 40px;
}
.teacher-img {
  width: 100%;
}
.bold-desc {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 20px;
}
.email-desc {
  text-align: center;
  color: #03a9f4;
  font-size: 20px;
}
.bold-title {
  color: #4f81bd;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.right-content {
  font-size: 20px;
  line-height: 36px;
}
@media screen and (max-width: 900px) {
  .item-container {
    display: block;
  }
  .left {
    width: 100%;
    text-align: center;
  }
  .right {
    width: 100%;
  }
  .teacher-img {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/teacher/fangqiming.vue